import raw from './overseasImages.json';

export type SchoolImage = { file: string; sourceUrl: string; bytes: number };
export const overseasImages: Record<string, SchoolImage[]> = raw as Record<string, SchoolImage[]>;
export function imagesFor(slug: string): SchoolImage[] { return overseasImages[slug] ?? []; }
